<template>
    <header v-if="this.$route.path != '/news/details' && this.$route.path != '/product/details' && this.$route.path != '/case/details'">
        <ul class="h_1 d_f">
            <li class="h_1 d_f_1" v-for="(item,index) in nav" :key="index">
                <router-link :to="item.path" class="d_b h_1 M_x c_grey">
                    {{item.name}}
                </router-link>
            </li>
        </ul>
    </header>
</template>

<script>
import header from './header.js'
export default {
    ...header
}
</script>

<style lang='scss' scoped>

    header{
        height: 13.298vw;
    }
    li{
        text-align: center;
        a{
            position: relative;
            line-height: 13.298vw;
            &::after{
                content: '';
                position: absolute;
                width: 0.133vw;
                height: 2.4vw;
                background-color: #D8D8D8;
                right: 0.067vw;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
    li .router-link-exact-active{
        color: #202737;
        background-color: rgba(0,103,204,.1);
        &::before{
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 4vw;
            height: 0.533vw;
            background-color: #0067CC;
        }
    }
</style>